import createRoutine from '@/utils/createRoutine'

export const setStageGoal = createRoutine('setStageGoal')

export const onboardingGetters = {
  STAGE_GOAL: 'STAGE_GOAL'
}
